<template>
    <div class="pm-dashboard-btn-primary" @click="goToRoute(item.link)">
        <span :style="{ background: item.color}" class="pm-dashboard-btn-primary-title">{{ item.title }} <mdi style="margin: -2px -6px -2px 2px; float: right; color:#fff;">chevron-right</mdi></span>
        <div class="pm-dashboard-btn-primary-desc" v-html="item.text" />
    </div>
</template>
<style>
.pm-dashboard-btn-primary {
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    background: #fff;
    text-align: left;
}
.pm-dashboard-btn-primary-title {
    display: inline-block;
    font-size: min(3.2vw, 16px);
    color: #fff;
    border-radius: 3.2vw;
    padding: 2px 3.2vw;
    margin: 3.2vw 0 0 3.2vw;
    font-weight: bold;
}
.pm-dashboard-btn-primary-desc {
    display: inline-block;
    font-size: min(3.5vw, 13px);
    line-height: 1.2;
    padding: 2.5vw 3.2vw 4vw 3.2vw;
    letter-spacing: -0.35px;
}
.pm-dashboard-btn-primary-desc b {
    font-weight: bold;
}

@media (orientation: landscape) and (max-width: 999px) {
    .pm-dashboard-btn-primary-title {
        font-size: min(1.6vw, 11px);
        padding: 2px 3.2vw;
        margin: 2.2vw 0 0 2.2vw;
    }
    .pm-dashboard-btn-primary-desc {
        font-size: min(2vw, 18px);
        padding: 1.5vw 2.2vw 1vw 2.2vw;
    }
}

</style>
<script>
export default {
    props: {
        item: {
            /** @type {import('vue').PropType<import('@/types').DashboardItem>} */
            type: Object,
        }
    },
    computed: {
        // https://www.svgbackgrounds.com/#quantum-gradient
        quantumGradient() {
            return {
                backgroundColor: this.item.color,
                backgroundSize: 'cover',
                backgroundPosition: this.item.gradientPos,
                backgroundImage: this.item.gradient,
            };
        }
    },
    methods: {
        /**
         *
         * @param {string} location
         * @return {Promise<void>}
         */
        async goToRoute(location) {
            try {
                await this.$router.push(location);

                window.Tracker.logEvent({
                    event_label: location,
                    event_name: 'navigate_to',
                    event_value: 1,
                });
            } catch (error) {
                captureException(error);
            }
        },
    },
};
</script>
